export default {
  name: 'millesime',

  ui: {
    'zoneNav[]': '[js-millesime-zone-nav]',
    'catNav[]': '[js-millesime-cat-nav]',
    'modelNav[]': '[js-millesime-model-nav]',
    'slides[]': '[js-millesime-slide]'
  },

  events: [
    {
      on: 'click',
      target: 'zoneNav',
      handle(e) { this.navClicked(e) }
    },
    {
      on: 'click',
      target: 'catNav',
      handle(e) { this.navClicked(e) }
    },
    {
      on: 'click',
      target: 'modelNav',
      handle(e) { this.navClicked(e) }
    }
  ],

  componentDidMount() {
    this.slides = new Array()
    for (let i = 0; i < this.ui.slides.length; i++) {
      this.slides.push(this.ui.slides[i].getAttribute('data-id'))
    }

    window.emitterSingleton.on('slideChange', (swiper) => {
      const slideId = this.slides[swiper.activeIndex]
      console.log('Slide IDs match', slideId == swiper.slides[swiper.activeIndex].getAttribute('data-id'))
      const slideIdTokens = slideId.split('::')
      this.updateNavVisibility(this.ui.zoneNav, slideIdTokens[0], false)
      this.updateNavVisibility(this.ui.catNav, slideIdTokens[0] + '::' + slideIdTokens[1], true)
      this.updateNavVisibility(this.ui.modelNav, slideId, true)
    })
  },

  navClicked(e) {
    let target = e.target.getAttribute('data-target')
    if (target === null) {
      target = e.target.closest('[data-target]').getAttribute('data-target')
    }

    for (let i = 0; i < this.slides.length; i++) {
      if (this.slides[i].startsWith(target)) {
        window.emitterSingleton.trigger('slideTo', { id: 'millesime', index: i })

        return
      }
    }
  },

  updateNavVisibility(uiElements, target, hide) {
    const lastIndexOfSeparator = target.lastIndexOf('::')
    const targetBase = (lastIndexOfSeparator != -1) ? target.substring(0, lastIndexOfSeparator) : target
    for (let i = 0; i < uiElements.length; i++) {
      let elemTarget = uiElements[i].getAttribute('data-target')

      let hasClassCurrent = uiElements[i].classList.contains('current')
      if (target === elemTarget) {
        if (!hasClassCurrent) {
          uiElements[i].classList.add('current')
        }
      } else {
        if (hasClassCurrent) {
          uiElements[i].classList.remove('current')
        }
      }

      if (hide) {
        let hasClassHidden = uiElements[i].classList.contains('hidden')
        if (!elemTarget.startsWith(targetBase)) {
          if (!hasClassHidden) {
            uiElements[i].classList.add('hidden')
          }
        } else if (hasClassHidden) {
          uiElements[i].classList.remove('hidden')
        }
      }
    }
  }
}
